import InputCopy from './InputCopy';
export default InputCopy;
